(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-about"] && !Shopify.designMode) return;
  try {
    
(function () {

  function parseNumber(el) {
    var suffixSpan = el.querySelector('.sw-about-stat-suffix');
    var suffixText = suffixSpan ? suffixSpan.textContent : '';
    var raw = el.textContent.replace(suffixText, '').trim();

    var match = raw.match(/^([^0-9]*)([0-9]+)([^0-9]*)$/);

    if (!match) return null;

    return {
      prefix: match[1],
      target: parseInt(match[2], 10),
      infix: match[3],
      suffixSpan: suffixSpan,
      textNode: null
    };
  }


  function initCounter(el) {
    var data = parseNumber(el);

    if (!data) return null;

    var textNode = document.createTextNode(
      data.prefix + '0' + data.infix
    );

    data.textNode = textNode;

    el.textContent = '';
    el.appendChild(textNode);

    if (data.suffixSpan) {
      el.appendChild(data.suffixSpan);
    }

    return data;
  }


  function animateCounter(data, duration) {
    var start = performance.now();

    function easeOut(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function tick(now) {
      var progress = Math.min(
        (now - start) / duration,
        1
      );

      data.textNode.textContent =
        data.prefix +
        Math.round(easeOut(progress) * data.target) +
        data.infix;

      if (progress < 1) {
        requestAnimationFrame(tick);
      }
    }

    requestAnimationFrame(tick);
  }


  function initGrid(grid) {
    var counters = [];

    grid.querySelectorAll('.sw-about-stat-number').forEach(function (el) {
      var data = initCounter(el);

      if (data) {
        counters.push(data);
      }
    });

    if (!counters.length) return;

    var observer = new IntersectionObserver(function (entries) {

      entries.forEach(function (entry) {

        if (!entry.isIntersecting) return;

        counters.forEach(function (data, i) {
          setTimeout(function () {
            animateCounter(data, 1800);
          }, i * 100);
        });

        observer.disconnect();

      });

    }, {
      threshold: 0.3
    });

    observer.observe(grid);
  }


  /* =========================================
     STAT TAB / RED UNDERLINE
     ========================================= */

  function initStatTabs() {

    document.querySelectorAll('.sw-about-stats-grid').forEach(function (grid) {

      var items = grid.querySelectorAll('.sw-about-stat-item');

      if (!items.length) return;


      // First tab active by default
      items[0].classList.add('active');


      // Click event
      items.forEach(function (item) {

        item.addEventListener('click', function () {

          // Remove active from all
          items.forEach(function (tab) {
            tab.classList.remove('active');
          });

          // Add active to clicked item
          item.classList.add('active');

        });

      });

    });

  }


  function run() {

    // Counter animation
    document
      .querySelectorAll('.sw-about-stats-grid')
      .forEach(initGrid);

    // Tab / underline functionality
    initStatTabs();

  }


  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', run);

  } else {

    run();

  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sw-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {

  var TRANSITION = 500;

  function initSlider(section) {
    if (section._swTmReady) return;
    section._swTmReady = true;

    var track = section.querySelector('.sw-testimonials-track');
    if (!track) return;

    var wrapper = section.closest('.sw-testimonials-section') || section.parentElement;
    var prevBtn = wrapper.querySelector('.sw-testimonials-prev');
    var nextBtn = wrapper.querySelector('.sw-testimonials-next');

    var origCards = Array.from(track.children);
    var total     = origCards.length;
    if (total === 0) return;

    var delay    = parseInt(section.dataset.autoplayDelay, 10) || 6000;
    var current  = 0;
    var lastMove = 0;
    var timer    = null;

    /* Clone all cards once — appended clones enable seamless forward loop */
    origCards.forEach(function (c) { track.appendChild(c.cloneNode(true)); });

    function getVisible() {
      var w = window.innerWidth;
      if (w >= 900) return 3;
      if (w >= 600) return 2;
      return 1;
    }

    function cardStep() {
      var c0 = track.children[0];
      var c1 = track.children[1];
      if (!c0 || !c1) return 0;
      return c1.getBoundingClientRect().left - c0.getBoundingClientRect().left;
    }

    function setPos(index, animate) {
      track.style.transition = animate ? ('transform ' + TRANSITION + 'ms ease') : 'none';
      track.style.transform  = 'translateX(' + (-cardStep() * index) + 'px)';
    }

    /* Time-based guard — replaces busy flag which can get permanently stuck */
    function canMove() {
      return Date.now() - lastMove > TRANSITION + 80;
    }

    /* ---- Advance (forward, loops) ---- */
    function advance() {
      if (!canMove()) return;
      lastMove = Date.now();
      var step = getVisible();
      current += step;
      setPos(current, true);
      setTimeout(function () {
        if (current >= total) {
          current -= total;
          setPos(current, false);
          void track.offsetWidth;
        }
      }, TRANSITION + 60);
    }

    /* ---- Retreat (backward, loops) ---- */
    function retreat() {
      if (!canMove()) return;
      lastMove = Date.now();
      var step = getVisible();
      var next = current - step;
      if (next < 0) {
        /* Calculate destination within real cards */
        var dest = ((next % total) + total) % total;
        /* Silently jump to the clone of dest, then animate back */
        track.style.transition = 'none';
        track.style.transform  = 'translateX(' + (-cardStep() * (total + dest)) + 'px)';
        void track.offsetWidth; /* force synchronous reflow — commits the silent jump */
        current = dest;
        track.style.transition = 'transform ' + TRANSITION + 'ms ease';
        track.style.transform  = 'translateX(' + (-cardStep() * current) + 'px)';
      } else {
        current = next;
        setPos(current, true);
      }
    }

    /* ---- Autoplay ---- */
    function startAuto() { stopAuto(); timer = setInterval(advance, delay); }
    function stopAuto()  { clearInterval(timer); timer = null; }

    wrapper.addEventListener('mouseenter', stopAuto);
    wrapper.addEventListener('mouseleave', startAuto);

    /* ---- Nav buttons ---- */
    if (prevBtn) {
      prevBtn.addEventListener('click', function () { stopAuto(); retreat(); startAuto(); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { stopAuto(); advance(); startAuto(); });
    }

    /* ---- Touch drag ---- */
    var txStart     = 0;
    var txStartY    = 0;
    var txBase      = 0;
    var txMoved     = false;
    var txScrolling = false;

    track.addEventListener('touchstart', function (e) {
      txStart     = e.touches[0].clientX;
      txStartY    = e.touches[0].clientY;
      txBase      = -cardStep() * current;
      txMoved     = false;
      txScrolling = false;
      stopAuto();
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (txScrolling) return;
      var dx = e.touches[0].clientX - txStart;
      var dy = e.touches[0].clientY - txStartY;
      if (!txMoved) {
        if (Math.abs(dy) > Math.abs(dx)) { txScrolling = true; return; }
        if (Math.abs(dx) > 5) txMoved = true;
      }
      if (txMoved) {
        track.style.transition = 'none';
        track.style.transform  = 'translateX(' + (txBase + dx) + 'px)';
      }
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (!txScrolling && txMoved) {
        var delta = e.changedTouches[0].clientX - txStart;
        if (delta < -40)     { lastMove = 0; advance(); }
        else if (delta > 40) { lastMove = 0; retreat(); }
        else                   setPos(current, true);
      }
      startAuto();
    }, { passive: true });

    /* ---- Mouse drag ---- */
    var mxStart   = 0;
    var mxBase    = 0;
    var mDragging = false;
    var mMoved    = false;

    track.style.cursor = 'grab';

    track.addEventListener('mousedown', function (e) {
      mDragging = true;
      mMoved    = false;
      mxStart   = e.clientX;
      mxBase    = -cardStep() * current;
      track.style.cursor = 'grabbing';
      stopAuto();
      e.preventDefault();
    });

    document.addEventListener('mousemove', function (e) {
      if (!mDragging) return;
      var dx = e.clientX - mxStart;
      if (!mMoved && Math.abs(dx) > 5) mMoved = true;
      if (mMoved) {
        track.style.transition = 'none';
        track.style.transform  = 'translateX(' + (mxBase + dx) + 'px)';
      }
    });

    document.addEventListener('mouseup', function (e) {
      if (!mDragging) return;
      mDragging = false;
      track.style.cursor = 'grab';
      if (mMoved) {
        var delta = e.clientX - mxStart;
        if (delta < -40)     { lastMove = 0; advance(); }
        else if (delta > 40) { lastMove = 0; retreat(); }
        else                   setPos(current, true);
      }
      startAuto();
    });

    /* ---- Resize ---- */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { setPos(current, false); }, 200);
    }, { passive: true });

    /* ---- Init ---- */
    setPos(current, false);
    startAuto();
  }

  function initAll() {
    document.querySelectorAll('[data-sw-testimonials]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-sw-testimonials]');
    if (el) { el._swTmReady = false; initSlider(el); }
  });

})();

  } catch(e) { console.error(e); }
})();
})();
